<!--
*@KjfxRwList
*@author Ys
*@date 2023/1/10 17:11
-->
<template>
<div style="margin-top: 30px">
<div>
  <el-table :data="rwxxList" :height="tableHeight" style="width: 100%" border stripe fit  ref="rwTable"
            row-key="TBBH">
    <el-table-column type="index" label="序号" align="center" width="50">
      <template slot-scope="scope">
        <span>{{(pageIndex-1)*pageSize+scope.$index+1}}</span>
      </template>
    </el-table-column>
    <el-table-column prop="XMMC" label="项目名称" align="center" > </el-table-column>
    <el-table-column prop="YT" label="用途" align="center" > </el-table-column>
<!--    <el-table-column prop="XMDM" label="项目代码" align="center" width="240"> </el-table-column>-->
    <el-table-column  label="分析状态" align="center" width="140">
      <template slot-scope="scope">
        <span v-show="!scope.row.FXBG_ZT||scope.row.FXBG_ZT==='0'" >
          <el-tag type="info" style="color: #ff6926;font-weight: bold;">任务未开始</el-tag>
        </span>
        <span v-show="scope.row.FXBG_ZT==='1'" >
          <el-tag style="color: #ffca1e;font-weight: bold;" type="success">正在执行</el-tag>
        </span>
        <span v-show="scope.row.FXBG_ZT==='2'" >
          <el-tag type="success">分析完成</el-tag>
        </span>
        <span v-show="scope.row.FXBG_ZT==='3'" >
          <el-tag type="danger">执行失败</el-tag>
        </span>
        <span v-show="scope.row.FXBG_ZT==='4'" >
          <el-tag type="warning">执行超时</el-tag>
        </span>
        <span v-show="scope.row.FXBG_ZT==='5'" >
          <el-tag>任务取消</el-tag>
        </span>
        <span v-show="scope.row.FXBG_ZT==='-1'" >
          <el-tag type="danger">程序崩溃引起的失败</el-tag>
        </span>
        <span v-show="scope.row.FXBG_ZT==='-999'" style="color: #000000;font-weight: bold;">
          不确定的状态值
        </span>
      </template>
    </el-table-column>
    <el-table-column prop="CJSJ" :formatter="formatDate" label="创建时间" align="center" width="160"> </el-table-column>
<!--    <el-table-column prop="LXR" label="联系人" align="center" width="140"> </el-table-column>-->
<!--    <el-table-column prop="LXDH" label="联系电话" align="center" width="140"> </el-table-column>-->
    <el-table-column prop="FXFA" label="分析方案" align="center" width="140"> </el-table-column>
    <el-table-column
      align="center"
      width="150"
      label="获取报告"
    >
      <template slot-scope="scope">
        <span v-show="!scope.row.TOTAL_FXBG">
          <svg t="1673398869352" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2930" width="32" height="32"><path d="M533.333333 96c229.76 0 416 186.24 416 416S763.093333 928 533.333333 928 117.333333 741.76 117.333333 512 303.573333 96 533.333333 96z m0 64C338.922667 160 181.333333 317.589333 181.333333 512S338.922667 864 533.333333 864 885.333333 706.410667 885.333333 512 727.744 160 533.333333 160z m32 116.608v220.992l163.2 144.554667-42.410666 47.893333-184.789334-163.626667v-249.813333h64z" fill="#1677FF" p-id="2931"></path></svg>
        </span>
        <span v-show="scope.row.TOTAL_FXBG" id="downLoad" @click="downLoadFxbg(scope.row.TOTAL_FXBG)">
          <svg t="1673399384125" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4035" width="32" height="32"><path d="M828.975746 894.125047 190.189132 894.125047c-70.550823 0-127.753639-57.18542-127.753639-127.752616L62.435493 606.674243c0-17.634636 14.308891-31.933293 31.93227-31.933293l63.889099 0c17.634636 0 31.93227 14.298658 31.93227 31.933293l0 95.821369c0 35.282574 28.596292 63.877843 63.87682 63.877843L765.098927 766.373455c35.281551 0 63.87682-28.595268 63.87682-63.877843l0-95.821369c0-17.634636 14.298658-31.933293 31.943526-31.933293l63.877843 0c17.634636 0 31.933293 14.298658 31.933293 31.933293l0 159.699212C956.729385 836.939627 899.538849 894.125047 828.975746 894.125047L828.975746 894.125047zM249.938957 267.509636c12.921287-12.919241 33.884738-12.919241 46.807049 0l148.97087 148.971893L445.716876 94.89323c0-17.634636 14.300704-31.94762 31.933293-31.94762l63.875796 0c17.637706 0 31.945573 14.312984 31.945573 31.94762l0 321.588299 148.97087-148.971893c12.921287-12.919241 33.875528-12.919241 46.796816 0l46.814212 46.818305c12.921287 12.922311 12.921287 33.874505 0 46.807049L552.261471 624.930025c-1.140986 1.137916-21.664416 13.68365-42.315758 13.69286-20.87647 0.010233-41.878806-12.541641-43.020816-13.69286L203.121676 361.13499c-12.922311-12.933567-12.922311-33.884738 0-46.807049L249.938957 267.509636 249.938957 267.509636z" fill="#2aa515" p-id="4036"></path></svg>
        </span>
        <span v-show="scope.row.TOTAL_FXBG" id="ewmDownLoad"  @click="downLoadFxbgForPhone(scope.row.TOTAL_FXBG)">
          <svg t="1675232388833" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2816" width="32" height="32"><path d="M874.666667 553.877333V746.666667h-192v-128.021334h-64v258.986667h-64V554.666667h192v127.978666h64v-128.768h64zM469.333333 554.666667v320H149.333333V554.666667h320z m405.333334 256v64h-192v-64h192z m-469.333334-192h-192v192h192v-192z m-64 64v64h-64v-64h64z m128-533.333334v320H149.333333V149.333333h320z m405.333334 0v320H554.666667V149.333333h320z m-469.333334 64h-192v192h192v-192z m405.333334 0h-192v192h192v-192z m-469.333334 64v64h-64v-64h64z m405.333334 0v64h-64v-64h64z" fill="#2c2c2c" p-id="2817"></path></svg>
        </span>
      </template>
    </el-table-column>
  </el-table>
  <!--分页工具-->
  <el-pagination @size-change="sizeChange" @current-change="currentChange"
                 :page-sizes="pageSizes" :page-size="pageSize" :total="total"
                 :current-page.sync="pageIndex"
                 background layout="total, sizes, prev, pager, next, jumper">
  </el-pagination>
</div>
  <br>
  <el-button  @click="goToFxfa" >返回</el-button>

  <el-dialog
    title="查看分析报告"
    center
    top="20vh"
    :visible.sync="ewmVisible"
    append-to-body
    width="30%">
    <div v-if="ewmVisible" class="qrcode" ref="qrCodeUrl"></div>
    <span slot="footer" class="dialog-footer">
     <el-button @click="ewmVisible = false">关 闭</el-button>
  </span>
  </el-dialog>
</div>
</template>

<script>
  import API from '../../../../api/ApiConfig'
  import {ajaxPost} from '../../../../util/AjaxhttpRequest'
  import $ from 'jquery'
  import Cookie from 'cookies-js'
  import {myFormatDate} from '../../../../util/utils'
  import QRCode from 'qrcodejs2'
  var  reFreshListTimer;
  export default {
    name: 'KjfxRwList',
    props: [],
    components: {},
    data () {
      return {
        ewmVisible:false,
        //存在标题时样式
        // tableHeight: window.innerHeight - 450,
        tableHeight: window.innerHeight - 350,
        token: Cookie.get("wwJcptToken"),
        dlzh: Cookie.get("dlzh"),
        rwxxList:[],
        //列表分页
        pageSizes: [10, 20, 40, 100],
        pageSize: 10,
        total: 0,
        totalPage: 0,
        pageIndex: 1,
        filterPrams:{

        }
      }
    },
    mounted () {
    this.getKjfxRwList();
    },
    methods: {
      downLoadFxbgForPhone(path){
        let url = API.fxbgDownLoad;
        url += "?path=" + encodeURI(path);
        this.ewmVisible=true;
        this.$nextTick(()=>{
          var qrcode = new QRCode(this.$refs.qrCodeUrl, {
            text: url, // 需要转换为二维码的内容
            width: 400,
            height: 400,
            colorDark: '#000000',
            colorLight: '#ffffff',
            correctLevel: QRCode.CorrectLevel.H
          })
        })
      },
      downLoadFxbg(path){
        let url = API.fxbgDownLoad;
        url += "?path=" + encodeURI(path);
        window.open(url)
      },
      goToFxfa(){
        if (reFreshListTimer) {
          window.clearTimeout(reFreshListTimer);
        }
        this.token=undefined;
        this.$emit('backToFxfa');
      },
      reFreshList() {
        const self = this;
        reFreshListTimer = window.setTimeout(() => {
          self.getKjfxRwList();
          if (reFreshListTimer) {
            window.clearTimeout(reFreshListTimer);
            if (Cookie.get("wwJcptToken")&&this.token){
            self.reFreshList();
            }
          }
        }, 10000)
      },
      formatDate(row) {
        return myFormatDate(row.CJSJ,"yyyy-MM-dd HH:mm:ss");
      },
      currentChange(val) {
        this.pageIndex = val;
        this.getKjfxRwList();
      },
      sizeChange(val) {
        this.pageSize = val;
        this.getKjfxRwList();
      },
      getKjfxRwList(){
        if (!this.token){
          return
        }
        ajaxPost(API.KjfxProvider,"queryKjfxTask",[this.token,this.dlzh,JSON.stringify(this.filterPrams),this.pageIndex,this.pageSize]).then(result=>{
          let res=JSON.parse(result)
          this.total=res.totalItems
          this.rwxxList=res.items
          this.reFreshList()
        }).catch(err=>{
          this.$message.error(err)
        })
      }
    },
    deactivated(){
      if (reFreshListTimer) {
        window.clearTimeout(reFreshListTimer);
      }
    },
    beforeDestroy(){
      if (reFreshListTimer) {
        window.clearTimeout(reFreshListTimer);
      }
    },
  }
</script>

<style scoped>
#downLoad:hover,#ewmDownLoad:hover{
  cursor: pointer;
}
.qrcode {
  display: inline-block;
  width: 450px;
  height: 450px;
  background-color: #fff;
  padding: 6px;
  box-sizing: border-box;
}
  /deep/ .el-dialog--center .el-dialog__body{
    text-align: center;
  }
</style>




// WEBPACK FOOTER //
// src/components/kjfx/main/components/KjfxRwList.vue